// extracted by mini-css-extract-plugin
export default {"pageContainer":"payments_pageContainer__dU41q"};